import { render, staticRenderFns } from "./TriggerWithVolunteer.vue?vue&type=template&id=0c5f1fda&scoped=true&"
import script from "./TriggerWithVolunteer.vue?vue&type=script&lang=js&"
export * from "./TriggerWithVolunteer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5f1fda",
  null
  
)

export default component.exports